import type { AudioAssetDefinition } from './audio-manifest'

export type AudioAssetMap<Key extends string> = Record<Key, AudioAssetDefinition>

export async function loadAudioSamples<Key extends string>(
  context: AudioContext,
  assets: AudioAssetMap<Key>,
  fetchAudio: typeof fetch = globalThis.fetch,
): Promise<Map<Key, AudioBuffer>> {
  const loaded = new Map<Key, AudioBuffer>()
  await Promise.all(
    (Object.entries(assets) as [Key, AudioAssetDefinition][]).map(async ([key, asset]) => {
      for (const url of asset.sources) {
        try {
          const response = await fetchAudio(url)
          if (!response.ok) continue
          const encoded = await response.arrayBuffer()
          const decoded = await context.decodeAudioData(encoded.slice(0))
          loaded.set(key, decoded)
          return
        } catch {
          // Try the next browser-compatible encoding.
        }
      }
    }),
  )
  return loaded
}
